import { useRef } from 'react';
import { Container } from '@/components/ui/container';
import { Service } from '@/types/service.types';
import { ServiceCardContent } from './service-card-content';
import { ServiceFeatures } from './service-features';

interface ServiceCardProps {
	service: Service;
	index: number;
}

export function ServiceCard({ service, index }: ServiceCardProps) {
	const cardRef = useRef<HTMLDivElement>(null);

	// Determine the order based on the index
	const contentOrder = index % 2 === 0 ? 1 : 2;
	const featuresOrder = index % 2 === 0 ? 2 : 1;

	return (
		<div ref={cardRef} className="flex items-center relative z-10">
			<Container>
				<div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
					<ServiceCardContent service={service} index={index} order={contentOrder} />
					<ServiceFeatures features={service.features} index={index} order={featuresOrder} />
				</div>
			</Container>
		</div>
	);
}
